import { TitleS } from "@components/Typography"
import React, { FC } from "react"
import * as S from "./FilterButton.styles"

type FilterButtonProps = {
  status: "idle" | "active" | "disabled"
  title: string
  amount: number | string
  handleClick: () => void
}

export const FilterButton: FC<FilterButtonProps> = ({
  handleClick,
  status,
  title,
  amount,
}) => {
  return (
    <S.Button onClick={handleClick} data-status={status}>
      <TitleS>{title}</TitleS>
      <S.Amount>{amount}</S.Amount>
    </S.Button>
  )
}
